import { Stack, Typography } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';
import { Checkbox } from '../../controls/checkbox';
import type { DynamicGridItem } from '../types';

type DynamicGridDrawerRowProps = {
  item: DynamicGridItem;
  visible: boolean;
  onToggle: () => void;
};

export const DynamicGridDrawerRow = ({
  item,
  visible,
  onToggle,
}: DynamicGridDrawerRowProps) => (
  <Stack
    direction="row"
    py={8}
    px={24}
    alignItems="center"
    onClick={onToggle}
    data-testid={`widget-toggle-${item.id}`}
    sx={{
      cursor: 'pointer',
      borderBottom: '1px solid',
      borderColor: tokens.theme.border.structural.neutralSubtle,
      '&:hover': { backgroundColor: tokens.theme.bg.action.surfaceHover },
    }}
  >
    <Checkbox
      checked={visible}
      onChange={onToggle}
      onClick={(e) => e.stopPropagation()}
      size="small"
      sx={{ mr: 16 }}
      testId="widget-checkbox"
    />
    <Stack>
      <Typography variant="P12B">{item.title}</Typography>
      <Typography
        variant="P12R"
        sx={{ color: tokens.theme.fg.structural.secondary }}
      >
        {item.description}
      </Typography>
    </Stack>
  </Stack>
);
